
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sdk",
      function () {
        return require("private-next-pages/sdk/index.js");
      }
    ]);
  